
import {
  Badge,
  Box,
  Button,
  Divider,
  Flex,
  Grid,
  Heading,
  HStack,
  IconButton,
  Image,
  SimpleGrid,
  Stack,
  Text,
  useColorMode,
  useColorModeValue,
  VStack
} from "@chakra-ui/react";
import { FaInstagram, FaLinkedin, FaTwitter } from "react-icons/fa";

import { useNavigate } from "react-router-dom";

import { CheckIcon } from "@chakra-ui/icons";

import Chart from "../assets/images/HomeIcone/chart.png";
// import Desktop from "../assets/images/HomeIcone/desktop.png";
import Moneybag from "../assets/images/HomeIcone/money-bag.png";
import MoneyWomen from "../assets/images/HomeIcone/money.png";
import People from "../assets/images/HomeIcone/people.png";

import AiHub from "../assets/images/AboutAdspressoIcon/AI_hub.png";
import BidMultiplier from "../assets/images/AboutAdspressoIcon/Bid_Multiplier.png";
import BotNull from "../assets/images/AboutAdspressoIcon/Bot_Nullifier.png";
import Bulk from "../assets/images/AboutAdspressoIcon/Bulk_Uploading.png";
import CreativeScoring from "../assets/images/AboutAdspressoIcon/Creative_Scoring.png";
import IntegratedIns from "../assets/images/AboutAdspressoIcon/Integrated_Insights.png";
import Rule from "../assets/images/AboutAdspressoIcon/Rule.png";
import Desktop from "../assets/images/AboutAdspressoIcon/Single_View_Dashboard.png";
import AICallCenter from "../assets/images/AboutAdspressoIcon/ai-call-centre.png";
import AILander from "../assets/images/AboutAdspressoIcon/ai-lander.png";
import Whatsapp from "../assets/images/AboutAdspressoIcon/whatsapp.png";
import NavbarLanding from "./NavbarLanding";
//

const plans = [
  {
    name: "Free for 7 days",
    price: "$0/mo",
    description: "Coming soon",
    button: "Get started for free",
    features: [
      "20 Background Changes",
      "20 Creative Variations",
      "4 Video Creation Credits",
      "Bulk Upload",
      "Bulk Campaign Creator",
      "Bot Nullifier",
      "Bid Multiplier",
      "AI Image",
      "AI Video",
      "Ad Rules",
    ],
    note: "For first-timers exploring everything Hustle AI has to offer. No card, no pressure.",
  },
  {
    name: "Starter",
    price: "$9.99",
    description: "Billed monthly",
    originalPrice: "$14.99",
    badge: "33% OFF",
    button: "Coming soon",
    features: [
      "100 Background Changes",
      "100 Creative Variations",
      "10 Video Creation Credits",
      "Bulk Upload",
      "Bulk Campaign Creator",
      "Ad Rules",
      "AI Image",
      "AI Video",
    ],
    note: "For marketers working with static creatives and just getting started with AI-powered tools.",
  },
  {
    name: "Pro",
    price: "$18.99",
    description: "Billed monthly",

    originalPrice: "$29.99",
    badge: "36% OFF",
    limitedOffer: true,
    button: "Coming soon",
    features: [
      "200 Background Changes",
      "200 Creative Variations",
      "20 Video Creation Credits",
      "Bulk Upload",
      "Bulk Campaign Creator",
      "Ad Rules",
      "AI Image",
      "AI Video",
      "Rental Ad Account",
      "Bid Multiplier",
      "Bot Nullifier",
    ],
    note: "For marketers scaling fast with automation, video, and serious AI muscle.",
  },
  {
    name: "Enterprise",
    price: "Contact Us",
    description: "Billed monthly",

    button: "Coming soon",
    features: [
      "API Volume Based Discount",
      "Commercial Terms",
      "Top Security & Privacy",
      "Done-for-You Creative Service",
      "Dedicated Account Manager",
      "24/7 Priority Customer Support",
    ],
    note: "For ad wizards handling high-volume madness, with custom workflows, dedicated support, and enterprise-grade security.",
  },
];

const LandingPage = () => {
  // const bgColor = useColorModeValue("background.light", "background.dark");
  const cardBg = useColorModeValue("white", "card.dark");
  // const borderColor = useColorModeValue("gray.200", "brand.650");
  const headingColor = useColorModeValue("brand.900", "brand.100");
  const grayColor = useColorModeValue("black", "#9FA0A5");
  const whiteColor = useColorModeValue("black", "white");
  const darkPurple = useColorModeValue("#9074C0", "#58448D");
  const textColorPlans = useColorModeValue("mediumPurple.500", "mediumPurple.600");
  const bgMain = useColorModeValue("blueDark.light", "blueDark.dark");
  // const { colorMode } = useColorMode();
  const bg = useColorModeValue("#ffffff", "#0b0420");
  // const textColor = useColorModeValue(" #40225f", " #FA72F7");
  //
  const cardBorder = useColorModeValue("brand.200", "brand.700");
  const textColor = useColorModeValue("purple.500", "brand.500");
  const subTextColor = useColorModeValue("brand.400", "brand.700");
  const bgColor = useColorModeValue("background.light", "background.dark");
  const borderColor = useColorModeValue("brand.100", "brand.700");
  const hoverBorderColor = useColorModeValue("brand.300", "brand.300");
  const footerBg = useColorModeValue("purple.500", "brand.500");
  const btnBg = useColorModeValue("purple.500", "background.dark");
  const iconColor = useColorModeValue("white", "white");
  const hoverBg = useColorModeValue("whiteAlpha.300", "whiteAlpha.200");
  const textSubColor = useColorModeValue("gray.700", "gray.400");
  const btnColor = useColorModeValue("white", "brand.500");
  //
  const navigate = useNavigate();

  const { colorMode, setColorMode } = useColorMode();

  return (
    <Box bg={bgColor} color={textColor} minH="100vh">
      {/* <Flex
        justify="flex-start"
        align="center"
        justifyContent="center"
        mb={{ base: "20px", md: "30px" }}
        pt={{ base: "20px", md: "60px" }}
      >
        <Link to={"/"}>
          <Image
            src={LogoHustle} // Replace with actual path
            alt="Logo"
            width={{ base: "90px", md: "170px" }}
          />
        </Link>
      </Flex> */}
      <NavbarLanding /> {/* ✅ Keep it here */}
      <Box
        px={6}
        py={{ base: 6, md: "50px" }}
        pb={{ base: "40px", md: "80px" }}
        maxW={{ base: "100%", md: "1180px" }}
        mx="auto"
      >
        <Heading
          textAlign="center"
          fontWeight="light"
          lineHeight="1"
          fontSize={{ base: "5xl", md: "9xl" }}
        >
          <HStack justify="center" spacing={2}>
            <Text>Make it Rain</Text>
            <Image
              src={MoneyWomen} // 👈 Replace with your actual image path
              alt="emoji"
              boxSize={{ base: "40px", md: "120px" }}
              display="inline-block"
            />
          </HStack>
        </Heading>
        <Text textAlign="center" mt={2} mb={6} fontSize={{ base: "16px", md: "35px" }}>
          The AI super app <Box as="br" display={{ base: "block", md: "none" }} /> your bank account
          will fall in love with
        </Text>

        {/* CTA Buttons */}
        <Stack
          direction={{ base: "row", md: "row" }}
          justify={{ base: "space-between", md: "center" }}
          spacing={{ base: 2, md: 8 }}
          mb={{ base: 20, md: "90px" }}
          mt={{ base: 10, md: "60px" }}
        >
          <Flex align={"center"} justify="center">
            <Box
              pos="relative"
              role="group"
              w={{ base: "150px", md: "200px" }}
              h={{ base: "50px", md: "100%" }}
            >
              <Box
                as="button"
                pos="absolute"
                top="0"
                left="0"
                right="0"
                bottom="0"
                w="100%"
                h="100% "
                zIndex={2}
                // p={10}
                bg={colorMode === "light" ? "white" : bgColor}
                transition="all 0.3s ease"
                _groupHover={{
                  top: "-8px",
                  left: "-8px",
                }}
                borderRadius="25px"
                cursor="pointer"
                display="flex"
                alignItems="center"
                justifyContent="center"
                fontSize={{ base: "16px", md: "20px" }}
                color={textColor}
                onClick={() => navigate("/")}
                borderColor={textColor}
                borderWidth="1px"
                variant={"outline"}
              >
                Join The Beta
              </Box>

              <Box
                as="button"
                bg="linear-gradient(90deg,rgba(56, 187, 230, 1) 0%, rgba(254, 113, 255, 1) 46%, rgba(237, 100, 121, 1) 63%, rgba(247, 235, 13, 1) 99%)"
                pos="absolute"
                top="0"
                left="1px"
                right="0"
                bottom="0"
                w={"calc(100% - 2px)"}
                h="100%"
                zIndex={1}
                borderRadius="25px"
                cursor="pointer"
                outline="none"
                border="none"
              />
            </Box>
          </Flex>

          <Flex align="center" justify="center">
            <Box pos="relative" role="group" w={{ base: "150px", md: "200px" }} h="50px">
              {/* Top button with text */}
              <Box
                as="button"
                pos="absolute"
                top="0"
                left="0"
                right="0"
                bottom="0"
                w="100%"
                h="100%"
                zIndex={2}
                bg={colorMode === "light" ? "white" : bgColor}
                transition="all 0.3s ease"
                _groupHover={{
                  top: "-8px",
                  left: "-8px",
                }}
                borderRadius="25px"
                cursor="pointer"
                display="flex"
                alignItems="center"
                justifyContent="center"
                fontSize={{ base: "16px", md: "20px" }}
                color={textColor}
                borderColor={textColor}
                borderWidth="1px"
                onClick={() =>
                  window.open(
                    "https://calendly.com/stuti-b-blinkdigital/30-minute-meetings",
                    "_blank"
                  )
                }
              >
                Book a Demo
              </Box>

              {/* Background gradient layer */}
              <Box
                as="button"
                bg="linear-gradient(90deg, rgba(56, 187, 230, 1) 0%, rgba(254, 113, 255, 1) 46%, rgba(237, 100, 121, 1) 63%, rgba(247, 235, 13, 1) 99%)"
                pos="absolute"
                top="0"
                left="1px"
                right="0"
                bottom="0"
                w="calc(100% - 2px)"
                h="100%"
                zIndex={1}
                borderRadius="25px"
                cursor="pointer"
                outline="none"
                border="none"
              />
            </Box>
          </Flex>
        </Stack>

        <Grid
          templateColumns={{ base: "repeat(2, 1fr)", md: "repeat(4, 1fr)" }}
          gap={{ base: 6, md: 10 }}
        >
          {[
            ["76%", "drop in CPC"],
            ["50%", "cut in CPR"],
            ["59%", "reduction in CPM"],
            ["ROAS", "held longer & more stable than Meta BM"],
          ].map(([title, desc], idx) => (
            <Box key={idx} pos="relative" role="group" display="flex" flexDirection="column">
              <Flex
                borderRadius="20px"
                flexDirection="column"
                flexGrow="1"
                py={6}
                px={{ base: 6, md: 10 }}
                position="relative"
                zIndex={2}
                bg={colorMode === "light" ? "white" : bgColor}
                border="1px solid"
                borderColor={textColor}
                transition="all 0.3s ease"
                // justifyContent="space-between"
                alignItems="center"
                minHeight={{ base: "140px", md: "180px" }}
                _groupHover={{
                  transform: "translate(-10px, -10px)",
                }}
                rowGap={{ base: 2, md: 0 }}
                columnGap={{ base: 2, md: 4 }}
                textAlign="center"
              >
                <Text fontSize={{ base: "30px", md: "50px" }} fontWeight="bold" color={textColor}>
                  {title}
                </Text>
                <Text fontSize={{ base: "14px", md: "md" }} color={textColor}>
                  {desc}
                </Text>
              </Flex>

              {/* Gradient Shadow Layer */}
              <Box
                pos="absolute"
                top="0"
                left="0"
                right="0"
                bottom="0"
                borderRadius="20px"
                zIndex={1}
                _before={{
                  content: '""',
                  pos: "absolute",
                  top: "10px",
                  left: "10px",
                  right: "0px",
                  bottom: "0px",
                  borderRadius: "20px",
                  bg: "linear-gradient(90deg, rgba(56,187,230,1) 0%, rgba(254,113,255,1) 46%, rgba(237,100,121,1) 63%, rgba(247,235,13,1) 99%)",
                  opacity: 0,
                  transition: "all 0.3s ease",
                  zIndex: -1,
                }}
                _groupHover={{
                  _before: {
                    opacity: 1,
                    top: "8px",
                    left: "8px",
                  },
                }}
              />
            </Box>
          ))}
        </Grid>
      </Box>
      {/* Header */}
      {/* Core Features Section */}
      <Box
        id="features"
        py={{ base: "40px", md: "50px" }}
        maxW={{ base: "100%", "2xl": "1500px" }}
        m="auto"
      >
        <Heading
          fontSize={{ base: "48px", md: "60px" }}
          fontWeight="light"
          color={textColor}
          mb={{ base: 8, md: 12 }}
          textAlign="center"
        >
          Core Features
        </Heading>

        <SimpleGrid
          columns={{ base: 1, md: 2, lg: 3 }}
          px={{ base: 6, md: "50px" }}
          spacing={{ base: "60px", md: "50px" }}
        >
          {[
            {
              img: AICallCenter,
              title: "AI Call Center Support",
              desc: "Transform business calls with AI-powered pathways by unifying number management, flow builder, inbound/outbound calling, and call logging in one system. Built-in lead filtering ensures only high-intent leads reach sales teams, driving smarter optimisation, targeting, and ROI.",
            },
            {
              img: AILander,
              title: "AI Lander Generator",
              desc: "Transform ideas into production-ready interfaces instantly with AI-powered Text-to-UI, Image-to-UI, and Figma-to-UI. From simple concepts to complex applications, Canva generates beautiful, responsive designs and code in seconds.",
            },
            {
              img: Whatsapp,
              title: "AI WhatsApp Chatbot",
              desc: "Automate WhatsApp Business with AI-powered conversation pathways that connect directly through Meta Business Manager. Build intelligent flows, manage multiple numbers, and optimise engagement with real-time analytics.",
            },
            {
              img: Desktop,
              title: "Single View Dashboard",
              desc: "Simplify campaign management and reduce oversight errors with a unified view of all your Meta ad accounts.",
            },
            {
              img: Bulk,
              title: "Bulk Uploading",
              desc: "Cut ad setup time and boost ROAS by up to 30% by launching creatives and campaigns in bulk across multiple accounts, get to market faster and smarter.",
            },
            {
              img: BotNull,
              title: "Bot Nullifier",
              desc: "Improve ROI by eliminating bot traffic and automatically excluding inactive users after deploying high-intent audiences from across ad accounts.",
            },
            {
              img: AiHub,
              title: "AI Hub",
              desc: "Generate high-converting static and video creatives with a single click - reduce design time, improve CVRs, and drive up to 30% lower CPI.",
            },
            {
              img: Rule,
              title: "Rule Automation",
              desc: "Automate campaign actions to reduce manual monitoring and achieve consistent optimisation, even while you sleep.",
            },
            {
              img: CreativeScoring,
              title: "Creative Scoring",
              desc: "Accelerate decision-making with AI-backed creative scores, quickly spot what’s working and scale it to improve CTR and ROAS.",
            },
            {
              img: IntegratedIns,
              title: "Integrated Insights",
              desc: "Track granular performance data across creatives, CTAs, and campaigns to increase testing speed and reduce wasted ad spend.",
            },
            {
              img: BidMultiplier,
              title: "Bid Multiplier",
              desc: "Boost bids by up to 100% on your top-performing cohorts with a single click, say goodbye to manual targeting for good.",
            },
          ].map((feature, index) => (
            <Box key={index} pos="relative" role="group" display="flex" flexDirection="column">
              {/* Top Card */}
              <Flex
                flexDirection="row"
                flexGrow="1"
                py={6}
                px={{ base: 6, md: 10 }}
                position="relative"
                zIndex={2}
                bg={colorMode === "light" ? "white" : bgColor}
                border="1px solid"
                borderColor={textColor}
                borderRadius="20px"
                transition="all 0.3s ease"
                justifyContent="space-between"
                minHeight={{ base: "260px", md: "290px" }}
                _groupHover={{
                  transform: "translate(-10px, -10px)",
                }}
                rowGap={{ base: 2, md: 0 }}
                columnGap={{ base: 2, md: 4 }}
              >
                <Flex flexDirection="column" justifyContent="space-between">
                  <Text
                    fontWeight="medium"
                    lineHeight={{ base: "1.3", md: "1.4" }}
                    fontSize={{ base: "24px", md: "2xl" }}
                    mb={2}
                    color={textColor}
                  >
                    {(() => {
                      const words = feature.title.split(" ");
                      const lastWord = words.pop();
                      return (
                        <>
                          {words.join(" ")} <br /> {lastWord}
                        </>
                      );
                    })()}
                  </Text>
                  <Text fontSize="14px" fontWeight="light" color={textColor}>
                    {feature.desc}
                  </Text>
                </Flex>

                <Image
                  alignSelf="center"
                  src={feature.img}
                  alt={feature.title}
                  boxSize={{ base: "70px", md: "90px" }}
                  mb={2}
                />
              </Flex>

              {/* Gradient Shadow Layer */}
              <Box
                pos="absolute"
                top="0"
                left="0"
                right="0"
                bottom="0"
                borderRadius="20px"
                zIndex={1}
                _before={{
                  content: '""',
                  pos: "absolute",
                  top: "10px",
                  left: "10px",
                  right: "0px",
                  bottom: "0px",
                  borderRadius: "20px",
                  bg: "linear-gradient(90deg, rgba(56,187,230,1) 0%, rgba(254,113,255,1) 46%, rgba(237,100,121,1) 63%, rgba(247,235,13,1) 99%)",
                  opacity: 0,
                  transition: "all 0.3s ease",
                  zIndex: -1,
                }}
                _groupHover={{
                  _before: {
                    opacity: 1,
                    top: "8px",
                    left: "8px",
                  },
                }}
              />
            </Box>
          ))}
        </SimpleGrid>
      </Box>
      <Box
        id="fitfor"
        py={{ base: "40px", md: "50px" }}
        maxW={{ base: "100%", md: "1180px" }}
        mx="auto"
        pb={{ base: "80px" }}
      >
        {/* your existing content here */}
        {/* The Hustle Fits Section */}
        <Heading
          fontSize={{ base: "48px", md: "60px" }}
          fontWeight="light"
          color={textColor}
          mb={6}
          textAlign="center"
        >
          The Hustle Fit
        </Heading>

        <Flex
          direction={{ base: "column", md: "row" }}
          justify="space-around"
          align="center"
          textAlign="center"
          mb={{ base: 0, md: 10 }}
          gap={{ base: 10, md: 0 }}
        >
          {[
            {
              icon: People,
              label: "Agencies \n with 10+ clients",
            },
            {
              icon: Chart,
              label: "Scaling \n growth teams",
            },
            {
              icon: Moneybag,
              label: "High-scale \n media buyers",
            },
          ].map((item, index) => (
            <Flex
              key={index}
              align="center"
              justify="space-between"
              // px={{ base: 0, md: 6 }}
              py={{ base: 0, md: 6 }}
              position="relative"
              textAlign="center"
              gap={{ base: 4, md: 2 }}
            >
              <Image src={item.icon} alt={item.label} boxSize={{ base: "60px", md: "80px" }} />
              <Text
                whiteSpace="pre-line"
                fontWeight="light"
                fontSize={{ base: "xl", md: "2xl" }}
                color={textColor}
                textAlign="left"
                // maxW="250px"
              >
                {item.label}
              </Text>

              {/* Vertical line between items - only on desktop */}
              {index < 2 && (
                <Box
                  display={{ base: "none", md: "block" }}
                  height="40px"
                  width="1px"
                  bg="gray.400"
                  position="absolute"
                  right="-100px"
                  top="50%"
                  transform="translateY(-50%)"
                />
              )}
            </Flex>
          ))}
        </Flex>
      </Box>
      <Box id="plans" py={16} px={{ base: 4, md: "80px" }} minH="100vh">
        <VStack spacing={3} mb={12}>
          <Heading fontSize={{ base: "48px", md: "60px" }} fontWeight="light" color={textColor}>
            Plans
          </Heading>
        </VStack>

        <SimpleGrid columns={{ base: 1, md: 2, xl: 4 }} spacing={8}>
          {plans.map((plan, i) => (
            <Box key={i} pos="relative" role="group" display="flex" flexDirection="column">
              <Flex
                flexDirection="column"
                flexGrow="1"
                py={6}
                px={{ base: 6, md: 10 }}
                position="relative"
                zIndex={10}
                bg={colorMode === "light" ? "white" : bgColor}
                border="1px solid"
                borderColor="mediumPurple"
                borderRadius="20px"
                transition="all 0.3s ease"
                justifyContent="space-between"
                minHeight={{ base: "200px", md: "580px" }}
                _groupHover={{
                  transform: "translate(-10px, -10px)",
                }}
                rowGap={{ base: 2, md: 0 }}
              >
                <Box>
                  {plan.badge && (
                    <Badge
                      color={cardBg}
                      bg="#401E64"
                      position="absolute"
                      top={3}
                      right={3}
                      fontSize="0.7rem"
                      px={2}
                      py={1}
                      rounded="md"
                    >
                      {plan.badge}
                    </Badge>
                  )}

                  <Heading fontSize="xl" mb={2} color={textColorPlans}>
                    {plan.name}
                  </Heading>
                  <Flex flexDirection="row" columnGap="20px">
                    {plan.originalPrice && (
                      <Text fontSize="xl" textDecoration="line-through" color={grayColor}>
                        {plan.originalPrice}
                      </Text>
                    )}
                    <Text fontSize="xl" fontWeight="bold" color={whiteColor}>
                      {plan.price}
                    </Text>
                  </Flex>
                  {plan.description && (
                    <Text mb={4} color={darkPurple}>
                      {plan.description}
                    </Text>
                  )}
                  <Button
                    w="full"
                    mb={4}
                    bgGradient="linear(to-r, brand.500, brand.300)"
                    color={grayColor}
                    rounded="full"
                    fontWeight="medium"
                    _hover={{
                      bgGradient: "linear(to-r, brand.400, brand.200)",
                    }}
                    isDisabled
                  >
                    {plan.button}
                  </Button>
                  <Divider orientation="horizontal" mb={4} />
                  <VStack align="start" spacing={2} mb={4}>
                    <Text color={textColorPlans}>Includes:</Text>

                    {plan.features.map((feature, idx) => (
                      <HStack key={idx}>
                        {/* <CheckIcon  /> */}

                        <Box
                          display="inline-flex"
                          alignItems="center"
                          justifyContent="center"
                          bg="green.500"
                          color="white"
                          borderRadius="3px"
                          w="4"
                          h="4"
                        >
                          <CheckIcon boxSize={3} />
                        </Box>
                        <Text fontSize="sm" color={grayColor}>
                          {feature}
                        </Text>
                      </HStack>
                    ))}
                  </VStack>
                </Box>
                <Box minH={{ base: "30px", md: "90px" }}>
                  <Divider orientation="horizontal" mb={4} />
                  <Text fontSize="xs" color="gray.500">
                    {plan.note}
                  </Text>
                </Box>
              </Flex>
              <Box
                pos="absolute"
                top="0"
                left="0"
                right="0"
                bottom="0"
                borderRadius="20px"
                zIndex={1}
                _before={{
                  content: '""',
                  pos: "absolute",
                  top: "10px",
                  left: "10px",
                  right: "0px",
                  bottom: "0px",
                  borderRadius: "20px",
                  bg: "linear-gradient(90deg, rgba(56,187,230,1) 0%, rgba(254,113,255,1) 46%, rgba(237,100,121,1) 63%, rgba(247,235,13,1) 99%)",
                  opacity: 0,
                  transition: "all 0.3s ease",
                  zIndex: -1,
                }}
                _groupHover={{
                  _before: {
                    opacity: 1,
                    top: "8px",
                    left: "8px",
                  },
                }}
              />
            </Box>
          ))}
        </SimpleGrid>
      </Box>
      {/* Footer Section */}
      <Box
        bg={useColorModeValue("#40225f", " #FA72F7")}
        w="full"
        py={4}
        // mt={{ base: 0, md: 12 }}
      >
        <Flex
          maxW={{ base: "100%", md: "1180px" }}
          mx="auto"
          px={4}
          direction={{ base: "column", md: "row" }}
          justify="space-between"
          align="center"
          textAlign={{ base: "center", md: "left" }}
        >
          <Text fontSize="sm" color={useColorModeValue("white", "white")}>
            © {new Date().getFullYear()} Hustle. All rights reserved.
          </Text>

          <HStack spacing={8} mt={{ base: 3, md: 0 }}>
            <IconButton
              as="a"
              href="https://x.com/blink_india"
              aria-label="Twitter"
              icon={<FaTwitter />}
              size="sm"
              variant="ghost"
              fontSize="24px"
              color={useColorModeValue("white", "white")}
              _hover={{ bg: "whiteAlpha.300", transform: "scale(1.1)" }}
            />
            <IconButton
              as="a"
              href="https://www.linkedin.com/company/blink-digital/" // ✅ updated to Facebook URL
              aria-label="LinkedIn"
              icon={<FaLinkedin />}
              size="sm"
              variant="ghost"
              fontSize="24px"
              color={useColorModeValue("white", "white")}
              _hover={{ bg: "whiteAlpha.300", transform: "scale(1.1)" }}
            />
            <IconButton
              as="a"
              href="https://www.instagram.com/blink.digital"
              aria-label="Instagram"
              icon={<FaInstagram />}
              size="sm"
              variant="ghost"
              fontSize="24px"
              color={useColorModeValue("white", "white")}
              _hover={{ bg: "whiteAlpha.300", transform: "scale(1.1)" }}
            />
          </HStack>
        </Flex>
      </Box>
    </Box>
  );
};

export default LandingPage;
